import { useState, type ReactNode } from 'react';
import { Skeleton } from '@heroui/react';
import { cn } from '@/shared/lib/cn';

/**
 * Иллюстрация с маскотом (`public/illustrations/*.webp`, прозрачный фон;
 * генератор — `scripts/scenes/generate-mascot-illustrations.mjs`). Пока
 * картинка грузится — шиммер той же формы, что у карточек практики. Не
 * загрузилась (или файла ещё нет) — `fallback`: то, что стояло на этом месте
 * до картинки, а не вечный шиммер и не пустое место.
 *
 * Размер задаёт вызывающий (`className`, например `size-48`): блок
 * квадратный и не прыгает, когда картинка приходит.
 */
export function Illustration({
  src,
  className,
  fallback = null,
}: {
  src: string;
  className?: string;
  fallback?: ReactNode;
}) {
  const [state, setState] = useState<'loading' | 'ready' | 'failed'>('loading');

  if (state === 'failed') return fallback;

  return (
    <div aria-hidden="true" className={cn('relative aspect-square shrink-0', className)}>
      {state === 'loading' && <Skeleton className="absolute inset-0 h-full w-full rounded-3xl" />}
      <img
        src={src}
        alt=""
        decoding="async"
        onLoad={() => setState('ready')}
        onError={() => setState('failed')}
        className="relative h-full w-full object-contain"
      />
    </div>
  );
}
